<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <a href="#collapseCardListActivity" class="d-block card-header py-3"
                        :class="activities.length > 0 ? 'collapsed' : ''" data-toggle="collapse" role="button"
                        :aria-expanded="activities.length > 0 ? false : true" aria-controls="collapseCardListActivity">
                        <h6 class="m-0 font-weight-bold text-primary">Filtros <span v-if="activities.length > 0"> - {{
                            activities.length }} atividade(s) encontrada(s)</span></h6>
                    </a>
                    <div class="collapse" :class="activities.length > 0 ? '' : 'show'" id="collapseCardListActivity">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-5 col-sm-5 col-xs-12">
                                    <label for="">Usuário</label>
                                    <multiselect v-model="user_multiselect" :options="users_options"
                                        :custom-label="userWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectUser">

                                        <template #noResult>
                                            Nenhum usuário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-7 col-sm-7 col-xs-12">
                                    <label for="">Descrição atividade</label>
                                    <input type="text" class="form-control" v-model="user.description"
                                        placeholder="Ex: Atividade xyz">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Status</label>
                                    <multiselect v-model="user.status" :options="status_options"
                                        placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                        :deselect-label="'Clique para remover'">
                                        <template #noResult>
                                            Nenhum status encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Atividades a partir de</label>
                                    <input type="date" class="form-control" v-model="user.from">
                                </div>
                                <div class="col-lg-4 col-sm-4 col-xs-12">
                                    <label for="">Atividades até</label>
                                    <input type="date" class="form-control" v-model="user.to">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-6 col-xs-6 col-sm-12">
                                    <button class="btn btn-primary " @click="loadData"><i
                                            class="fa fa-check"></i>Aplicar
                                        filtros</button>
                                    <button class="btn btn-danger ml-3" @click="cleanAdvancedSearch"><i
                                            class="fa fa-trash"></i>Limpar
                                        filtros</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">

            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Atividades <span v-if="user.name != ''"><i
                                    class="fa fa-arrow-right"></i> {{ user.name }}</span>
                            <br><small><span v-if="total_itens > 0">Total registros encontrados: {{
                                formatDecimal(total_itens)
                                    }}</span></small>
                        </h6>
                        <button class="btn btn-info btn-sm" @click="showModalNewActivity"><i class="fa fa-plus"></i>
                            Nova
                            atividade</button>
                    </div>
                    <div class="card-body" :class="activities.length <= 0 ? 'card-body-no-spaccing' : ''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th class="text-center">Prazo</th>
                                        <th class="text-center">Finalização</th>
                                        <th>Status</th>
                                        <th class="text-center">Anexo</th>
                                        <th class="text-center">Comentários</th>
                                        <th class="text-center">Checklist</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(activity) in activities" :key="activity.id">
                                        <td class="align-middle break-word pointer" @click="editActivity(activity.id)"
                                            v-if="activity.status != 'Finalizada' && activity.status != 'Cancelada'">
                                            <span :tooltip="'Criada por ' + activity.created_by">{{ activity.description
                                            }}
                                            </span>
                                            <span v-if="activity.link != ''" class="badge badge-info">{{
                                                activity.link.model }}
                                                - {{ activity.link.name }}</span>
                                            <span v-if="activity.dependences.length > 0"
                                                class="badge badge-danger ml-2 pointer"
                                                @click="showModalListDependence(activity.dependences)">
                                                {{ activity.dependences.length }} dependência(s)</span>
                                        </td>
                                        <td class="align-middle break-word" v-else><span
                                                :tooltip="'Criada por ' + activity.created_by">{{ activity.description
                                                }}
                                            </span>
                                            <span v-if="activity.link != ''" class="badge badge-info">{{
                                                activity.link.model }}
                                                - {{ activity.link.name }}</span>
                                            <span v-if="activity.dependences.length > 0"
                                                class="badge badge-danger ml-2 pointer"
                                                @click="showModalListDependence(activity.dependences)">
                                                {{ activity.dependences.length }} dependência(s)</span>
                                        </td>
                                        <td class="text-center align-middle">{{ activity.deadline_formatted }} </td>
                                        <td class="text-center align-middle">{{ activity.end ? activity.end_formatted :
                                            '-' }}
                                        </td>
                                        <td class="align-middle" v-if="activity.status == 'Pendente'"><span
                                                class="badge badge-warning">{{
                                                    activity.status }}</span></td>
                                        <td class="align-middle" v-else-if="activity.status == 'Em atraso'"><span
                                                class="badge badge-danger">{{
                                                    activity.status }}</span></td>
                                        <td class="align-middle" v-else-if="activity.status == 'Finalizada'"><span
                                                class="badge badge-success">{{
                                                    activity.status }}</span></td>
                                        <td class="align-middle" v-else-if="activity.status == 'Cancelada'"><span
                                                class="badge badge-light">{{
                                                    activity.status }}</span></td>
                                        <td class="align-middle" v-else><span class="badge badge-secondary">{{
                                            activity.status
                                                }}</span></td>
                                        <td class="text-center" v-if="activity.file != ''"><button class="btn btn-link"
                                                @click="downloadFile(activity.file.id)"><i class="fa fa-download"></i>
                                                Baixar</button> <i class="fa fa-times pointer"
                                                @click="deleteAttachment(activity.file.id)"></i></td>
                                        <td class="text-center align-middle" v-else>-</td>
                                        <td class="text-center align-middle">
                                            <span @click="showModalComments(activity)"
                                                class="pointer badge badge-warning"
                                                v-if="activity.comments.length > 0">{{ activity.comments.length }}
                                                comentário(s)</span>
                                            <span @click="showModalComments(activity)"
                                                class="pointer badge badge-secondary" v-else>{{ activity.comments.length
                                                }} comentário(s)</span>
                                        </td>
                                        <td class="text-center align-middle">
                                            <span @click="showModalChecklist(activity)"
                                                class="pointer badge badge-warning"
                                                v-if="activity.checklist.length > 0">{{ activity.checklist.length }}
                                                item(ens)</span>
                                            <span @click="showModalChecklist(activity)"
                                                class="pointer badge badge-secondary" v-else>{{
                                                    activity.checklist.length }} item(ens)</span>
                                        </td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <button class="dropdown-item" @click="editActivity(activity.id)"
                                                        v-if="activity.status != 'Finalizada' && activity.status != 'Cancelada'">Editar</button>
                                                    <button class="dropdown-item"
                                                        v-if="activity.status != 'Finalizada' && activity.status != 'Cancelada'"
                                                        @click="showModalActivityDependence(activity)">Atividade
                                                        dependente</button>
                                                    <button class="dropdown-item"
                                                        v-if="activity.status != 'Finalizada' && activity.status != 'Cancelada'"
                                                        @click="completed(activity.id)">Finalizar atividade</button>
                                                    <button class="dropdown-item"
                                                        v-if="activity.status != 'Finalizada' && activity.status != 'Cancelada'"
                                                        @click="cancelled(activity.id, false)">Cancelar
                                                        atividade</button>
                                                    <button type="button" class="dropdown-item"
                                                        v-if="activity.status == 'Finalizada' || activity.status == 'Cancelada'"
                                                        @click="reopen(activity.id)">Reabrir
                                                        atividade</button>
                                                    <button type="button" class="dropdown-item"
                                                        @click="duplicate(activity.id)">Duplicar atividade</button>
                                                    <button class="dropdown-item" v-if="activity.status != 'Finalizada'"
                                                        @click="deleteActivity(activity.id)">Excluir</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="activities.length > 0 && page > 1">
                                        <td colspan="9" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="activities.length <= 0">
                                        <td colspan="9" class="text-center">{{ label_no_register }}</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="modalDisplayNewActivity" class="modal" :style="{ display: modalDisplayNewActivity }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewActivity">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">{{ title_modal }} <br>
                                <h6 v-if="activity.dependence_id != ''"><span class="badge badge-danger">{{
                                    title_modal_dependence }} </span></h6>
                            </h5>
                            <button type="button" class="close" @click="closeModalNewActivity()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição da atividade*</label>
                                    <input type="text" class="form-control"
                                        placeholder="Ex: Enviar NF-e para o cliente XYZ" v-model="activity.description">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-6 col-sm-6 col-xs-12">
                                    <label for="">Usuário designado*</label>
                                    <multiselect v-model="user_multiselect" :options="users_options"
                                        :custom-label="userWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectUser">

                                        <template #noResult>
                                            Nenhum usuário encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-lg-6 col-sm-6 col-xs-12">
                                    <label for="">Prazo finalização* </label>
                                    <input type="datetime-local" class="form-control" v-model="activity.deadline">
                                    <small v-if="activity.dependence_id != ''">{{ deadline_dependence }}</small>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Atribuir atividade</label><br>
                                    <div class="wrapper input-group">

                                        <input type="text" id="searchSystem"
                                            class="form-control bg-light border-0 autocomplete-input autocomplete-input-activity small"
                                            placeholder="Pesquisar fornecedor,clientes,leads..." aria-label="Search"
                                            aria-describedby="basic-addon2" @keyup="search" v-model="searchInput"
                                            :disabled="activity.model_id != ''">
                                        <ul class="autocomplete-list">
                                            <li class="list-item pointer" v-for="(result, index) in results"
                                                :key="index" @click="toModule(result.id, result.model, result)">
                                                {{ result.model }} - {{ result.name }}
                                            </li>
                                        </ul>
                                        <div class="input-group-append">
                                            <button class="btn btn-light" type="button" @click="resetSearch()">
                                                <i class="fas fa-trash fa-sm"></i> Limpar pesquisa
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText @update-text="updateObservation" :modelValue="activity.observation"
                                        placeholderSend="Sem observações" ref="myChild"></editorText>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small>Tamanho máximo: 5MB</small>
                                    <input type="file" @change="handleFileChange">
                                </div>
                            </div>
                            <div class="row mt-3" v-if="activity.size != ''">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <small class="mt-5">Tamanho arquivo selecionado: {{ activity.size }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalNewActivity()"><i
                                    class="fa fa-ban"></i> Cancelar</button>
                            <button type="submit" class="btn btn-info" :disabled='!isDisabledNewActivity'><i
                                    class="fa fa-save"></i>
                                {{ button_modal }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayListDependence" class="modal" :style="{ display: modalDisplayListDependence }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="createNewActivity">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Atividades dependentes</h5>
                            <button type="button" class="close" @click="closeModalListDependence()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table" id="dataTable" width="100%" cellspacing="0">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Descrição</th>
                                            <th>Prazo</th>
                                            <th>Data Finalização</th>
                                            <th>Status</th>
                                            <th class="text-center">Anexo</th>
                                            <th>Atribuída a</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(activity, index) in dependences" :key="activity.id">
                                            <td class="align-middle">{{ index + 1 }}</td>
                                            <td class="align-middle">{{ activity.description }} <br>
                                                <span v-if="activity.dependences.length > 0"
                                                    class="badge badge-warning pointer"
                                                    @click="showModalListDependence(activity.dependences)">
                                                    {{ activity.dependences.length }} dependência(s)</span>
                                            </td>
                                            <td class="align-middle">{{ activity.deadline_formatted }} </td>
                                            <td class="align-middle">{{ activity.end ? activity.end_formatted : '-' }}
                                            </td>
                                            <td class="align-middle" v-if="activity.status == 'Pendente'"><span
                                                    class="badge badge-warning">{{
                                                        activity.status }}</span></td>
                                            <td class="align-middle" v-else-if="activity.status == 'Em atraso'"><span
                                                    class="badge badge-danger">{{
                                                        activity.status }}</span></td>
                                            <td class="align-middle" v-else-if="activity.status == 'Finalizada'"><span
                                                    class="badge badge-success">{{
                                                        activity.status }}</span></td>
                                            <td class="align-middle" v-else-if="activity.status == 'Cancelada'"><span
                                                    class="badge badge-light">{{
                                                        activity.status }}</span></td>
                                            <td class="align-middle" v-else><span class="badge badge-secondary">{{
                                                activity.status }}</span>
                                            </td>
                                            <td class="text-center align-middle" v-if="activity.file != ''"><button
                                                    class="btn btn-link" @click="downloadFile(activity.file.id)"><i
                                                        class="fa fa-download"></i>
                                                    Baixar</button></td>
                                            <td class="text-center" v-else>-</td>
                                            <td class="align-middle">{{ activity.user.name }} </td>
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-primary dropdown-toggle" type="button"
                                                        id="dropdownMenuButton" data-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false"
                                                        :disabled="activity.status == 'Finalizada'">
                                                        Ações
                                                    </button>
                                                    <div class="dropdown-menu animated--fade-in"
                                                        aria-labelledby="dropdownMenuButton">
                                                        <button type="button" class="dropdown-item"
                                                            v-if="activity.status != 'Finalizada'"
                                                            @click="cancelled(activity.id, true)">Cancelar
                                                            atividade</button>
                                                        <button type="button" class="dropdown-item"
                                                            v-if="activity.status != 'Finalizada'"
                                                            @click="deleteActivity(activity.id)">Excluir</button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalListDependence()"><i
                                    class="fa fa-ban"></i> Fechar</button>

                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div id="modalDisplayComments" class="modal" :style="{ display: modalDisplayComments }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content border-left-primary">
                    <div class="modal-header">
                        <h5 class="modal-title" id="newFileLabel">Comentários <br></h5>
                        <button type="button" class="close" @click="closeModalcomments()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 col-xs-12 col-sm-12">
                                <label for="">Novo comentário</label>
                                <div class="mention-wrapper">
                                    <textarea ref="textarea" v-model="comment.description" @input="onInput"
                                        @keydown.down.prevent="navigate(1)" @keydown.up.prevent="navigate(-1)"
                                        @keydown.enter.prevent="selectUser(activeIndex)"
                                        placeholder="Digite @ para mencionar alguém..."
                                        class="form-control textarea"></textarea>
                                    <ul v-if="showDropdown" class="dropdown-mention">
                                        <li v-for="(user, index) in filteredUsers" :key="user.id"
                                            :class="{ active: index === activeIndex }" @click="selectUser(index)">
                                            {{ user.name }}
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12 col-xs-12 col-sm-12">
                                <button type="button" class="btn btn-success" @click="saveComment()"><i
                                        class="fa fa-check"></i> Adicionar</button>
                            </div>
                        </div>
                        <hr>
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Usuário</th>
                                        <th>Data</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(comment) in comments" :key="comment.id">
                                        <td>{{ comment.description }} </td>
                                        <td>{{ comment.user.name }} </td>
                                        <td>{{ comment.created_at }} </td>
                                        <td><button @click="deleteComment(comment.id)" type="button"
                                                class="btn btn-danger"><i class="fa fa-trash"></i>
                                                Excluir</button></td>

                                    </tr>
                                    <tr v-show="comments.length <= 0">
                                        <td colspan="4" class="text-center">Nenhum comentário adicionado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="closeModalcomments()"><i
                                class="fa fa-ban"></i>
                            Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="modalDisplayChecklist" class="modal" :style="{ display: modalDisplayChecklist }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content border-left-primary">
                    <div class="modal-header">
                        <h5 class="modal-title" id="newFileLabel">Checklist <br></h5>
                        <button type="button" class="close" @click="closeModalChecklist()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 col-xs-12 col-sm-12">
                                <label for="">Descrição</label>
                                <input type="text" class="form-control" placeholder="Ex:1º - Resolver..."
                                    v-model="checklist.description">
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-md-12 col-xs-12 col-sm-12">
                                <button type="button" class="btn btn-success" @click="saveChecklist()"><i
                                        class="fa fa-check"></i> Adicionar item</button>
                            </div>
                        </div>
                        <hr>
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Descrição</th>
                                        <th>Criado por</th>
                                        <th>Finalizado por</th>
                                        <th>Última atualização</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(checklist) in checklists" :key="checklist.id">
                                        <td class="align-middle">
                                            <input type="checkbox" class="form-control"
                                                :checked="checklist.user_finisher != ''"
                                                @click="changeChecklist(checklist.id)" />
                                            <label for="weekday-1"></label>
                                        </td>
                                        <td>{{ checklist.description }}</td>
                                        <td>{{ checklist.user_create.name }} </td>
                                        <td>{{ checklist.user_finisher ? checklist.user_finisher.name : '-' }} </td>
                                        <td>{{ checklist.updated_at }} </td>
                                        <td><button @click="deleteChecklist(checklist.id)" type="button"
                                                class="btn btn-danger"><i class="fa fa-trash"></i>
                                                Excluir</button></td>

                                    </tr>
                                    <tr v-show="checklists.length <= 0">
                                        <td colspan="6" class="text-center">Nenhum item adicionado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click="closeModalChecklist()"><i
                                class="fa fa-ban"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import Multiselect from 'vue-multiselect'
import editorText from '../util/editor-text.vue';

export default {
    components: { Loading, Multiselect, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            enable_error_list: false,
            advanced_search_input: {},
            activities: [],
            users_options: [],
            title_modal: 'Nova atividade',
            title_modal_dependence: '',
            button_modal: 'Cadastrar',
            label_no_register: 'Selecione um usuário nos filtros para visualizar as suas atividades',
            modalDisplayNewActivity: 'none',
            modalDisplayListDependence: 'none',
            modalDisplayComments: 'none',
            modalDisplayChecklist: 'none',
            deadline_dependence: '',
            status_options: ['Pendente', 'Finalizada', 'Em atraso', 'Cancelada'],
            page: 1,
            last_page: 1,
            total_itens: 0,
            user_multiselect: '',
            users: {},
            dependences: [],
            comments: [],
            checklists: [],
            searchInput: '',
            results: [],
            comment: {
                'activity_id': '',
                'description': ''
            },
            checklist: {
                'activity_id': '',
                'description': ''
            },
            activity: {
                'description': '',
                'user_id': '',
                'deadline': '',
                'size': '',
                'observation': '',
                'archive': null,
                'activity_id': '',
                'dependence_id': '',
                'dependences': [],
                'model_name': '',
                'link': '',
                'model': '',
                'model_id': '',
            },
            user: {
                'user_id': '',
                'status': '',
                'description': '',
                'name': '',
                'from': '',
                'to': '',
            },
            content: "",
            showDropdown: false,
            activeIndex: 0,
            mentionStartIndex: null,
            searchText: "",
            mentions: [],
            users_mentions: []
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        },
        isDisabledNewActivity: function () {
            return this.activity.description != '' && this.activity.user_id != null && this.activity.deadline != null;
        },
        filteredUsers() {
            return this.users_mentions.filter(user =>
                user.name.toLowerCase().includes(this.searchText.toLowerCase())
            );
        }
    },
    mounted() {
        this.isLoading = false;
        const response_uses = this.getUsers();
        response_uses.then(() => {
            this.users_options = this.users.map(item => ({
                key: item.id,
                value: item.name + ' / ' + item.role
            }));

            this.users_mentions = this.users.map(item => ({
                id: item.id,
                name: item.name
            }));

        });
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.activities = {};
            this.loadData();
        },
        updateObservation(observation) {
            this.activity.observation = observation;
        },
        cleanAdvancedSearch() {
            this.activities = [];
            this.user.user_id = '';
            this.user_multiselect = '';
            this.user.status = '';
            this.user.description = '';
            this.user.from = '';
            this.user.to = '';
            this.user.name = '';
            this.total_itens = 0;
            this.label_no_register = 'Selecione um usuário nos filtros para visualizar as suas atividades';
        },

        handleSelectUser(option) {
            this.user.user_id = option.key;
            this.activity.user_id = option.key;
            this.user.name = option.value;

        },

        userWithLang({ value }) {
            return value;
        },
        resetSearch() {
            this.results = {};
            this.searchInput = '';
            this.activity.model_name = '';
            this.activity.model = '';
            this.activity.model_id = '';
        },
        toModule(id, module_selected, object) {
            this.resetSearch();
            this.searchInput = module_selected + ' - ' + object.name;
            this.activity.model_name = object.name;
            this.activity.model = module_selected;
            this.activity.model_id = id;
        },

        search() {
            const search = this.searchInput.trim();
            if (search.length > 1) {
                this.results = {};
                api.get('/search', {
                    params: {
                        'query': search
                    }
                })
                    .then((response) => {
                        this.results = response.data.original.categories
                            .concat(response.data.original.services)
                            .concat(response.data.original.suppliers)
                            .concat(response.data.original.clients)
                            .concat(response.data.original.leads);
                        this.results.forEach(item => {
                            if (this.results.includes(item.name)) {
                                this.results.push({
                                    'id': item.id,
                                    'name': item.name,
                                    'model': item.model
                                })
                            }

                        });
                    }).catch(error => {
                        handleRequestErrors(error)

                    })
            }
        },

        async getUsers() {
            this.isLoading = true;
            const response = api.get('/userListAll', { params: { 'no_client': true } })
                .then((response) => {
                    this.users = response.data.users;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },

        formatDecimal(number) {
            return new Intl.NumberFormat().format(number)
        },

        loadData() {
            if (this.user.user_id != '') {
                this.isLoading = true;
                api.get('/activity', {
                    params: {
                        'name': this.user.name,
                        'description': this.user.description,
                        'status': this.user.status,
                        'user_id': this.user.user_id,
                        'from': this.user.from,
                        'to': this.user.to,
                        'page': this.page
                    }
                })
                    .then((response) => {
                        this.isLoading = false;
                        this.total_itens = response.data.activities.length;
                        this.last_page = response.data.last_page;

                        if (this.page <= 1) {
                            this.activities = response.data.activities;
                        } else {
                            this.activities = this.activities.concat(response.data.activities);
                        }

                        if (this.page < response.data.last_page) {
                            this.page++;
                        } else {
                            this.page = 1;
                        }

                        if (this.activities.length <= 0) {
                            this.label_no_register = 'Nenhuma atividade encontrada para os filtros aplicados';
                        }

                    }).catch(error => {
                        this.isLoading = false;
                        handleRequestErrors(error.status);
                    })
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Selecione um usuário para filtrar suas atividades",
                    type: 'info'
                });
            }

        },

        createNewActivity(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            const formData = new FormData();
            formData.append('user_id', this.activity.user_id);
            formData.append('description', this.activity.description);
            formData.append('deadline', this.activity.deadline);
            if (this.activity.dependence_id != '') {
                formData.append('dependence_id', this.activity.dependence_id);
            }

            if (this.activity.observation != '') {
                formData.append('observation', this.activity.observation);
            }

            if (this.activity.archive != null) {
                formData.append('file', this.activity.archive);
            }

            if (this.activity.activity_id != '') {
                formData.append('activity_id', this.activity.activity_id);
            }

            if (this.activity.model_id != '') {
                formData.append('name', this.activity.model_name);
                formData.append('model', this.activity.model);
                formData.append('model_id', this.activity.model_id);
            }
            api.post('/activity', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Atividade registrada com sucesso!",
                        type: 'success'
                    });

                    this.closeModalNewActivity();
                    this.loadData();
                }).catch(error => {
                    this.isLoading = false;
                    this.closeModalNewActivity();
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })
        },

        editActivity(activity_id) {
            this.title_modal = 'Atualizar atividade';
            this.button_modal = 'Atualizar';
            this.activities.forEach(activity => {
                if (activity.id == activity_id) {
                    this.activity.description = activity.description;
                    this.activity.deadline = activity.deadline;
                    this.activity.observation = activity.observation;
                    this.activity.activity_id = activity_id;
                    this.activity.archive = null;
                    this.$refs.myChild.updateTextEditor(activity.observation);
                    if (activity.link != '') {
                        this.activity.name = activity.link.name;
                        this.activity.model = activity.link.model;
                        this.activity.model_id = activity.link.model_id;
                        this.searchInput = activity.link.model + ' - ' + activity.link.name;
                    } else {
                        this.activity.name = '';
                        this.activity.model = '';
                        this.activity.model_id = '';
                        this.searchInput = '';
                    }
                    this.showModalNewActivity();

                }
            });
        },


        showModalNewActivity() {
            this.modalDisplayNewActivity = 'block';
        },

        showModalListDependence(dependences) {
            this.dependences = dependences;
            this.modalDisplayListDependence = 'block';
        },

        showModalComments(activity) {
            this.mentions = [];
            this.comment.mentions = [];
            this.comment.activity_id = activity.id;
            this.comments = activity.comments;
            this.modalDisplayComments = 'block';
        },

        showModalChecklist(activity) {
            this.checklist.activity_id = activity.id;
            this.checklists = activity.checklist;
            this.modalDisplayChecklist = 'block';
        },


        closeModalNewActivity() {
            this.title_modal = 'Nova atividade';
            this.title_modal_dependence = '';
            this.button_modal = 'Cadastrar';
            this.activity.description = '';
            this.activity.deadline = '';
            this.activity.size = '';
            this.activity.activity_id = '';
            this.activity.dependence_id = '';
            this.deadline_dependence = '';
            this.activity.archive = null;
            this.$refs.myChild.updateTextEditor('');
            this.modalDisplayNewActivity = 'none';
        },

        closeModalListDependence() {
            this.dependences = [];
            this.modalDisplayListDependence = 'none';
        },

        closeModalcomments() {
            this.comments = [];
            this.modalDisplayComments = 'none';
        },

        closeModalChecklist() {
            this.checklist = [];
            this.modalDisplayChecklist = 'none';
        },

        showModalActivityDependence(activity) {
            this.title_modal_dependence = 'Dependência: ' + activity.description;
            this.activity.dependence_id = activity.id;
            this.deadline_dependence = '(Deve ser maior ou igual a ' + activity.deadline_formatted + ')';
            this.modalDisplayNewActivity = 'block';

        },
        saveComment() {
            if (this.comment.description == '') {
                this.$notify({
                    title: "Informação",
                    text: "Informe uma descrição para o comentário",
                    type: 'info'
                });
                return;
            }
            if(this.mentions.length > 0){
                this.comment.mentions = this.mentions;
            }
            
            api.post('activity/' + this.comment.activity_id + '/comment', this.comment)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Comentário adicionado com sucesso",
                        type: 'success'
                    });
                    this.comment.description = '';
                    this.comment.activity_id = '';
                    this.comments = [];
                    this.loadData();
                    this.closeModalcomments();

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        saveChecklist() {
            if (this.checklist.description == '') {
                this.$notify({
                    title: "Informação",
                    text: "Informe uma descrição para o checklist",
                    type: 'info'
                });
                return;
            }

            api.post('activity/' + this.checklist.activity_id + '/checklist', this.checklist)
                .then((response) => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Item adicionado ao checklist com sucesso",
                        type: 'success'
                    });

                    this.checklists = response.data.activity.checklist;
                    this.loadData();

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        changeChecklist(id) {
            this.isLoading = true;
            api.post('activity/' + id + '/checklistUpdate')
                .then((response) => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Checklist atualizado com sucesso",
                        type: 'success'
                    });

                    this.checklists = response.data.activity.checklist;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },
        deleteComment(comment_id) {
            this.$confirm(
                {
                    message: 'Deseja excluir o comentário?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('activity/' + comment_id + '/deleteComment')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Comentário excluído com sucesso",
                                        type: 'success'
                                    });

                                    this.comment.description = '';
                                    this.comment.activity_id = '';
                                    this.comments = [];
                                    this.loadData();
                                    this.closeModalcomments();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        deleteChecklist(checklist_id) {
            this.$confirm(
                {
                    message: 'Deseja remover o item da lista?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('activity/' + checklist_id + '/deleteChecklist')
                                .then((response) => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Item excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.checklists = response.data.activity.checklist;

                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        completed(id) {
            this.$confirm(
                {
                    message: 'Deseja concluir a atividade?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('activity/' + id + '/completed')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Atividade fiinalizada com sucesso",
                                        type: 'success'
                                    });

                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        cancelled(id, dependences) {
            this.$confirm(
                {
                    message: 'Deseja cancelar a atividade?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('activity/' + id + '/cancelled')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Atividade cancelada com sucesso",
                                        type: 'success'
                                    });
                                    if (dependences) {
                                        this.closeModalListDependence();
                                    }
                                    this.loadData();

                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        reopen(id) {
            this.$confirm(
                {
                    message: 'Deseja reabrir a atividade?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('activity/' + id + '/reopen')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Atividade reaberta com sucesso",
                                        type: 'success'
                                    });
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        duplicate(id) {
            this.$confirm(
                {
                    message: 'Deseja duplicar a atividade?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('activity/' + id + '/duplicate')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Atividade duplicada com sucesso",
                                        type: 'success'
                                    });
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        deleteActivity(id) {
            this.$confirm(
                {
                    message: 'Deseja excluir a atividade?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('activity/' + id + '/delete')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Atividade excluída com sucesso",
                                        type: 'success'
                                    });

                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        deleteAttachment(id) {
            this.$confirm(
                {
                    message: 'Deseja excluir o anexo?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('activity/' + id + '/deleteAttachment')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Anexo excluído com sucesso",
                                        type: 'success'
                                    });

                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        handleFileChange(event) {
            if (event.target.files[0] != undefined) {
                const sizeInBytes = event.target.files[0].size;
                const sizeInMB = sizeInBytes / (1024 * 1024);
                if (sizeInMB > 5) {
                    this.$notify({
                        title: "Informação",
                        text: "Seu arquivo excede o limite de envio. O máximo para envio são 5MB",
                        type: 'info'
                    });
                    this.activity.archive = null;
                } else {
                    this.activity.archive = event.target.files[0];
                }
                this.activity.size = sizeInMB.toFixed(2) + 'MB';

            } else {
                this.activity.size = '';
                this.activity.archive = null;
            }

        },

        generateRandom() {
            return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
                (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
            );
        },

        downloadFile(activity_file_id) {
            this.isLoading = true;
            api.get('/activity/' + activity_file_id + '/download', { responseType: 'blob' })
                .then((response) => {
                    const contentType = response.headers.get('Content-Type');
                    this.isLoading = false;
                    const blob = new Blob([response.data], { type: contentType })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob);
                    link.download = 'download_' + this.generateRandom();
                    link.click()
                    URL.revokeObjectURL(link.href);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        syncMentions() {
            this.mentions = this.mentions.filter(mention =>
                this.comment.description.includes(`@${mention.name}`)
            );
        },

        onInput() {
            this.syncMentions();
            const cursorPos = this.$refs.textarea.selectionStart;
            const textUntilCursor = this.comment.description.substring(0, cursorPos);
            const match = textUntilCursor.match(/@([\w\s]*)$/);

            if (match) {
                this.showDropdown = true;
                this.searchText = match[1];
                this.mentionStartIndex = cursorPos - match[0].length;
            } else {
                this.showDropdown = false;
            }
        },

        selectUser(index) {
            const user = this.filteredUsers[index];
            if (!user) return;

            const textarea = this.$refs.textarea;
            const cursorPos = textarea.selectionStart;

            const before = this.comment.description.substring(0, this.mentionStartIndex);
            const after = this.comment.description.substring(cursorPos);

            const mentionText = `@${user.name}`;

            this.comment.description = `${before}${mentionText} ${after}`;

            // ✅ Evita duplicidade
            if (!this.mentions.some(m => m.id === user.id)) {
                this.mentions.push({
                    id: user.id,
                    name: user.name
                });
            }

            this.showDropdown = false;

            this.$nextTick(() => {
                const pos = before.length + mentionText.length + 1;
                textarea.setSelectionRange(pos, pos);
                textarea.focus();
            });
        },

        navigate(direction) {
            if (!this.showDropdown) return;

            const max = this.filteredUsers.length - 1;
            this.activeIndex += direction;

            if (this.activeIndex < 0) this.activeIndex = 0;
            if (this.activeIndex > max) this.activeIndex = max;
        },
    }
}
</script>

<style>
.btnFull {
    width: 100%;
}

.ql-container {
    height: 65%;
}

.ql-editor {
    height: 180px;
    overflow: auto;
    color: #000;
    background: #fff;
}

.autocomplete-input-activity {
    background: #FFFFFF !important;
}

.autocomplete-list {
    position: absolute;
    list-style-type: none;
    background: #fff;
    width: 100%;
    margin-top: 50px;
    box-shadow: 0 0 10px #ddd;
    background: #e9e9e9;
    transition: all 300ms ease-out;
    transform: scale(1) translateY(0);
    transform-origin: center center;
    z-index: 99999;
    max-height: 300px;
    overflow-y: auto;
}

.list-item {
    padding: 10px;
    border-top: 1px solid #0000001f;
    background: #e9e9e9;
}

.list-item:hover {
    background: #d8d8d8;
}

.pointer {
    cursor: pointer;
}

.break-word {
    word-break: break-word;
}

.textarea {
    width: 100%;
    height: 120px;
    padding: 10px;
    font-size: 14px;
}

.dropdown-mention {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #ccc;
    max-height: 150px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin-top: 4px;
    z-index: 10;
}

.dropdown-mention li {
    padding: 8px;
    cursor: pointer;
}

.dropdown-mention li.active,
.dropdown-mention li:hover {
    background: #f0f0f0;
}
</style>